var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from '../../helpers/Api';
import Voucher from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this._vouchersCalendarReport = [];
        this.set = function (values) {
            _this.data = values.map(function (item) { return new Voucher(item); });
            _this.loaded = true;
            return _this.data;
        };
    }
    default_1.prototype.read = function (id) {
        var _this = this;
        // console.log('OperationLines/Store - read')
        if (id)
            return api.get("voucher/".concat(id, "?eager=[lines]"));
        return api.get('voucher?eager=[lines]').then(function (value) {
            return _this.set(value);
            // return value
        });
    };
    default_1.prototype.scan = function (checkin_url, stretch) {
        return api.post("voucher/valida/".concat(stretch, "/").concat(checkin_url));
    };
    default_1.prototype.pay = function (voucher, importe) {
        return api.post("voucher/pay/".concat(voucher.uuid), { importe: importe });
    };
    default_1.prototype.voucherReport = function (range, start, end) {
        var _this = this;
        this.loaded = false;
        return api.post("/tickets/calendar/".concat(range), { start: start, end: end }).then(function (reports) {
            return _this.setResultCalendarReport(reports);
        });
    };
    default_1.prototype.setResultCalendarReport = function (results) {
        this.loaded = true;
        this._vouchersCalendarReport = results.vouchers.map(function (result) { return new Voucher(result); });
        return this._vouchersCalendarReport;
    };
    __decorate([
        observable
    ], default_1.prototype, "data", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        observable
    ], default_1.prototype, "_vouchersCalendarReport", void 0);
    __decorate([
        action
    ], default_1.prototype, "voucherReport", null);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "setResultCalendarReport", null);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Vouchers/Store.ts
// module id = 709
// module chunks = 0